// The design system's line icons (single weight, 1.8 stroke). Names are what manifests reference.
const PATHS: Record<string, string> = {
  home: 'M4 11 12 4l8 7v9H4z M10 20v-6h4v6',
  plan: 'M3 5h18v16H3z M3 10h18M8 3v4M16 3v4',
  clock: 'M12 4a8 8 0 1 0 0 16 8 8 0 1 0 0-16z M12 8v4l3 2',
  records: 'M7 3h7l5 5v13H7z M14 3v5h5M10 13h6M10 17h6',
  report: 'M5 4h14v16H5z M9 9h6M9 13h6',
  channel: 'M4 5h16v11H9l-5 4z',
  bell: 'M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15L6 16Z M10 20a2 2 0 0 0 4 0',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  grid: 'M4 4h16v16H4z M4 12h16M12 4v16',
  settings: 'M12 8a4 4 0 1 0 0 8 4 4 0 1 0 0-8z M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1 7 17M17 7l2.1-2.1',
  lock: 'M5 11h14v10H5z M8 11V8a4 4 0 0 1 8 0v3',
  check: 'M20 6 9 17l-5-5',
  chevron: 'm9 6 6 6-6 6',
  back: 'm15 6-6 6 6 6',
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 1 0 0-14z m9 16-4-4',
  camera: 'M4 7h16v13H4z M9 7V5h6v2 M12 10a3 3 0 1 0 0 6 3 3 0 1 0 0-6z',
  warn: 'M12 3 2 20h20L12 3Z M12 10v5M12 17.5v.5',
  flag: 'M5 21V4h11l-1 4h5l-1 5h-5l1-4H7',
  ai: 'M12 3l2.5 5 5.5.8-4 3.9.9 5.5L12 15.6 7.1 18.2l.9-5.5-4-3.9L9.5 8z',
  users: 'M9 11a4 4 0 1 0 0-8 4 4 0 1 0 0 8z M2 21a7 7 0 0 1 14 0 M16 3.5a4 4 0 0 1 0 7.5 M22 21a7 7 0 0 0-5-6.7',
  sign: 'M4 18c4-8 6-8 8-4s4 4 8-6 M3 21h18',
  print: 'M6 9V3h12v6 M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2 M6 14h12v7H6z',
  plus: 'M12 5v14M5 12h14',
  send: 'M4 12 20 4l-4 16-4-7z',
  mic: 'M9 3h6v11H9z M5 11a7 7 0 0 0 14 0M12 18v3',
  map: 'M12 21s-6-5.5-6-10a6 6 0 0 1 12 0c0 4.5-6 10-6 10z M12 11m-2 0a2 2 0 1 0 4 0 2 2 0 1 0-4 0',
  chart: 'M4 20h16 M7 16V10 M12 16V5 M17 16v-7',
  refresh: 'M20 12a8 8 0 1 1-2.3-5.7 M20 4v5h-5',
  box: 'M3 8l9-4 9 4-9 4-9-4z M3 8v9l9 4 9-4V8 M12 12v9',
  wrench:'M14.5 6.5a4 4 0 0 0-5.3 5.1L3 17.8 6.2 21l6.2-6.2a4 4 0 0 0 5.1-5.3l-2.6 2.6-2.2-2.2z',
};

export const ICON_NAMES = Object.keys(PATHS);

export function Icon({ name, size = 20, className = '' }: { name: string; size?: number; className?: string }) {
  const d = PATHS[name] ?? PATHS.grid;
  return (
    <svg className={`i ${className}`} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      {d.split(' M').map((seg, i) => <path key={i} d={i === 0 ? seg : `M${seg}`} />)}
    </svg>
  );
}
